import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

interface ISecretToggleProps {
    enabled: boolean;
}

export const SecretToggle = styled.div<ISecretToggleProps>`
    --toggle-offset: ${(props: ISecretToggleProps): string => (props.enabled ? '18px' : '0')};
    --toggle-bgcolor: ${(props: ISecretToggleProps): string => props.enabled ? Variables.Colors.white : Variables.Colors.n30};
    --toggle-blur: ${(props: ISecretToggleProps): string => props.enabled ? '0px' : '5px'};
  
    display: flex;
    border-radius: 32px;
  
      -webkit-filter: blur(var(--toggle-blur));
      -moz-filter: blur(var(--toggle-blur));
      -o-filter: blur(var(--toggle-blur));
      -ms-filter: blur(var(--toggle-blur));
      filter: blur(var(--toggle-blur));

    align-items: center;
    background-color: var(--toggle-bgcolor);
    cursor: pointer;
  text-align: center;
  width: 100%;
`;

export const SecretToggleButtonContainer = styled.div<ISecretToggleProps>`
    --toggle-display: ${(props: ISecretToggleProps): string => props.enabled ? 'none' : 'inline'};
   display: var(--toggle-display);
   position: absolute;
   text-align: center;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   cursor: pointer;
`

export const SecretToggleButton = styled.button`
  cursor: pointer;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 8px;
  padding-left: 8px;
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  color: rgb(64, 68, 82);
  background-color: ${Variables.Colors.white};
  border: ${Variables.Borders.regular};
  border-radius: ${Variables.Rounded.medium};
  outline: none;
`;